import React, { useState } from 'react';
import { InputGroup, Button } from 'react-bootstrap';
import { FaFeather } from 'react-icons/fa';
import WorkflowAutocomplete from './WorkflowAutocomplete';
import AdvancedExpressionEditor from './AdvancedExpressionEditor';

function WorkflowAutocompleteWithExpand({
  value,
  onChange,
  allNodes,
  currentNode,
  edges,
  runbookVariables,
  placeholder,
  className,
  label,
  readOnly,
  ...otherProps
}) {
  const [showAdvancedEditor, setShowAdvancedEditor] = useState(false);

  return (
    <>
      <div style={{ position: 'relative' }}>
        <WorkflowAutocomplete
          value={value}
          onChange={onChange}
          allNodes={allNodes}
          currentNode={currentNode}
          edges={edges}
          runbookVariables={runbookVariables}
          placeholder={placeholder}
          className={className}
          style={{ paddingRight: '32px' }}
          {...otherProps}
        />
        <Button
          variant="link"
          size="sm"
          onClick={() => setShowAdvancedEditor(true)}
          title={readOnly ? "View full expression" : "Open advanced editor"}
          style={{
            position: 'absolute',
            right: '4px',
            top: '50%',
            transform: 'translateY(-50%)',
            padding: '2px 6px',
            color: readOnly ? '#0d6efd' : '#6c757d', // Blue in read-only mode to show it's clickable
            zIndex: 10,
            pointerEvents: 'auto' // Always allow clicking the feather button, even in read-only mode
          }}
        >
          <FaFeather size={12} />
        </Button>
      </div>

      <AdvancedExpressionEditor
        show={showAdvancedEditor}
        onHide={() => setShowAdvancedEditor(false)}
        value={value}
        onChange={onChange}
        label={label || 'Expression'}
        allNodes={allNodes}
        currentNode={currentNode}
        edges={edges}
        runbookVariables={runbookVariables}
        readOnly={readOnly}
      />
    </>
  );
}

export default WorkflowAutocompleteWithExpand;
